<template>
  <div v-if="visible" class="modal-backdrop">

    <div class="modal-content">

      <h5 class="modal-title mb-3 text-center">
        Paiement de l'hospitalisation
      </h5>


      <div class="modal-body-scroll">

        <div class="row">


          <!-- ============================
               COLONNE GAUCHE
          ============================== -->

          <div class="col-md-6">


            <div class="mb-3">

              <label class="form-label">
                Montant total
              </label>

              <input
                type="number"
                class="form-control"
                :value="totalHospitalisation"
                disabled
              />

            </div>



            <div class="mb-3">

              <label class="form-label">
                Total déjà payé
              </label>

              <input
                type="number"
                class="form-control"
                :value="totalDejaPaye"
                disabled
              />

            </div>



            <div class="mb-3">

              <label class="form-label">
                Reste à payer
              </label>

              <input
                type="number"
                class="form-control"
                :value="resteReel"
                disabled
              />

            </div>




            <div class="mb-3">

              <label class="form-label">
                Montant versé
              </label>


              <input

                type="number"

                class="form-control"

                v-model.number="montantVerse"

                :max="resteReel"

                :disabled="resteReel <= 0"

              />


            </div>




            <div class="mb-3">

              <label class="form-label">
                Reste après paiement
              </label>


              <input

                type="number"

                class="form-control"

                :value="resteApresPaiement"

                disabled

              />


            </div>



          </div>






          <!-- ============================
               COLONNE DROITE
          ============================== -->


          <div class="col-md-6">



            <div v-if="hospitalisation?.situation?.priseEnChargeSociale > 0" class="alert alert-info py-2 small">
              <i class="bi bi-heart me-1"></i>Prise en charge sociale : la clinique offre {{ hospitalisation.situation.priseEnChargeSociale }} F. Encaissez le reste sans assurance.
            </div>
            <!-- CONTRAT ASSURANCE PATIENT -->

            <div class="mb-3" v-if="!(hospitalisation?.situation?.priseEnChargeSociale > 0)">


              <label class="form-label">
                Assurance
              </label>



              <select

                class="form-control"

                v-model.number="contratAssuranceId"

              >


                <option :value="null">

                  Aucune assurance

                </option>




                <option

                  v-for="contrat in contratsAssurance"

                  :key="contrat.id"

                  :value="contrat.id"

                >


                  {{ contrat.assurance.nom }}

                  -

                  {{ contrat.numeroAssure }}

                  -

                  {{ contrat.tauxCouverture }} %


                </option>


              </select>



            </div>







            <!-- INFORMATION CONTRAT -->

            <div

              v-if="contratChoisi"

              class="alert alert-info"

            >


              <div>

                <strong>
                  Assurance :
                </strong>

                {{ contratChoisi.assurance.nom }}

              </div>


              <div>

                <strong>
                  Numéro assuré :
                </strong>

                {{ contratChoisi.numeroAssure }}

              </div>


              <div>

                <strong>
                  Couverture :
                </strong>

                {{ contratChoisi.tauxCouverture }} %

              </div>


            </div>







            <!-- PART ASSURANCE -->

            <div class="mb-3">


              <label class="form-label">
                Part Assurance
              </label>


              <input

                type="number"

                class="form-control"

                :value="partAssurance"

                disabled

              />
              <small v-if="repartition.erreur" class="text-warning d-block mt-1">{{ repartition.erreur }}</small>


            </div>







            <!-- PART PATIENT -->

            <div class="mb-3">


              <label class="form-label">
                Part Patient
              </label>


              <input

                type="number"

                class="form-control"

                :value="partPatient"

                disabled

              />


            </div>








            <!-- MODE PAIEMENT -->


            <div class="mb-3">


              <label class="form-label">
                Mode de paiement *
              </label>



              <select

                class="form-control"

                v-model.number="modePaiementId"

              >


                <option :value="null">

                  -- Sélectionner --

                </option>




                <option

                  v-for="mode in modesPaiement"

                  :key="mode.id"

                  :value="mode.id"

                >

                  {{ mode.nom }}

                </option>



              </select>



            </div>



          </div>



        </div>



      </div>







      <!-- ============================
             BOUTONS
      ============================== -->


      <div class="d-flex justify-content-end mt-3">


        <button

          class="btn btn-secondary me-2"

          @click="close"

        >

          Annuler

        </button>





        <button

          class="btn btn-success"

          :disabled="isLoading"

          @click="payer"

        >


          <span v-if="isLoading">

            Chargement...

          </span>


          <span v-else>

            Enregistrer

          </span>



        </button>



      </div>




    </div>


  </div>
</template>
<script>
import api, { messageErreur, notifier } from "@/api";

export default {

  props: {

    visible: Boolean,

    hospitalisation: Object,

    patientId: Number,

  },


  data() {

    return {

      isLoading:false,


      // contrat assurance patient
      contratAssuranceId:null,

      contratsAssurance:[],


      // paiement
      modePaiementId:null,

      montantVerse:0,

      // Répartition calculée par le serveur (plafond du contrat compris)
      repartition:{ partAssurance:0, partPatient:0, erreur:null },
      minuterieRepartition:null,


      modesPaiement:[],


    };

  },



  computed:{



    currentUser(){

      return this.$store.getters.user;

    },



    /**
     * Montant total hospitalisation
     */
    totalHospitalisation(){


      // Situation calculée par le serveur quand l'écran la fournit
      if (this.hospitalisation?.situation) {
        // Part offerte par la clinique (cas social) déjà retirée
        const sit = this.hospitalisation.situation;
        return Number(sit.montant || 0) - Number(sit.priseEnChargeSociale || 0);
      }

      return (

        this.hospitalisation
        ?.montantCalcule
        ?.montant

        ||

        0

      );


    },



    /**
     * Total déjà encaissé
     */
    totalDejaPaye(){


      if (this.hospitalisation?.situation) {
        return Number(this.hospitalisation.situation.dejaPaye || 0);
      }

      return (

        this.hospitalisation
        ?.totalEncaisse

        ||

        0

      );


    },



    /**
     * Reste réel
     */
    resteReel(){


      const reste =

        this.totalHospitalisation

        -

        this.totalDejaPaye;



      return reste > 0 ? reste : 0;


    },






    /**
     * Contrat choisi par le patient
     */
    contratChoisi(){


      return this.contratsAssurance.find(

        c => c.id === this.contratAssuranceId

      )

      ||

      null;


    },







    /**
     * Part prise en charge assurance
     */
    partAssurance(){
      return Number(this.repartition.partAssurance || 0);
    },

    partPatient(){
      if(!this.contratChoisi) return Number(this.montantVerse || 0);
      return Number(this.repartition.partPatient || 0);
    },








    /**
     * Reste après paiement
     */
    resteApresPaiement(){


      const reste =

        this.resteReel

        -

        this.montantVerse;



      return reste > 0 ? reste : 0;


    },




  },







  watch:{



    /**
     * Quand on change de contrat
     */
    contratAssuranceId(){


      this.montantVerse = 0;
      this.calculerRepartition();


    },

    montantVerse(){
      this.calculerRepartition();
    },




    /**
     * Quand le patient change
     */
    patientId(){


      this.fetchContratsAssurance();


    },




  },








  mounted(){


    this.fetchContratsAssurance();

    this.fetchModesPaiement();


  },








  methods:{

    /** Demande au serveur la répartition assurance / patient du montant versé. */
    calculerRepartition(){
      clearTimeout(this.minuterieRepartition);
      const montant = Number(this.montantVerse || 0);
      if(!this.contratChoisi || montant <= 0 || !this.hospitalisation?.id){
        this.repartition = { partAssurance:0, partPatient:montant, erreur:null };
        return;
      }
      this.minuterieRepartition = setTimeout(async () => {
        try{
          const res = await api.custom(`hospitalisations/${this.hospitalisation.id}/repartition?contrat=${this.contratChoisi.id}&montant=${montant}`, 'GET');
          if(Number(this.montantVerse || 0) === montant) this.repartition = res.data;
        }catch(e){
          this.repartition = { partAssurance:0, partPatient:montant, erreur:null };
        }
      }, 300);
    },






    /**
     * Chargement des contrats assurance du patient
     */
    async fetchContratsAssurance(){
    if (!this.$store.getters.hasModule('ASSURANCES')) { this.contratsAssurance = []; return; }


      if(!this.patientId)

        return;



      try{


        const res = await api.getItem(

          "patients",

          `${this.patientId}/contrats-assurance`

        );



        /**
         * API retourne directement un tableau
         */
        this.contratsAssurance =

          res.data || [];



        console.log(

          "Contrats assurance patient",

          this.contratsAssurance

        );



      }

      catch(error){


        console.error(

          "Erreur chargement contrats assurance",

          error

        );


      }



    },








    /**
     * Modes paiement
     */
    async fetchModesPaiement(){


      try{


        const res = await api.getItems(

          "moyen_paiements"

        );


        this.modesPaiement =

          res.data.data || [];



      }

      catch(error){


        console.error(error);


      }


    },










    close(){


      this.$emit("fermer");


    },









    /**
     * Enregistrement paiement
     */
    async payer(){





      if(!this.modePaiementId){


        notifier("Sélectionnez le mode de paiement.", "warning");


        return;


      }







      if(this.montantVerse <=0){


        notifier("Indiquez le montant versé.", "warning");


        return;


      }







      /*if(this.montantVerse > this.resteReel){


        alert(

          "Le montant dépasse le reste à payer."

        );


        return;


      }*/








      const payload = {



        montant:this.montantVerse,



        hospitalisation:

          this.hospitalisation.id,



        patient:

          this.patientId,



        modePaiement:

          this.modePaiementId,




        /**
         * Contrat assurance patient
         * null si aucune assurance
         */
        contratAssurance:

          this.contratAssuranceId

          ?

          `/api/v1/contrat_assurance_patients/${this.contratAssuranceId}`

          :

          null,





        createdBy:

          this.currentUser.id,




        type:

          "hospitalisation",




        datePaiement:

          new Date().toISOString(),



      };





      console.log(

        "PAYLOAD",

        payload

      );





      this.isLoading=true;






      try{


        await api.createItem(

          "paiement_hospitalisations",

          payload

        );



        this.$emit(

          "paiementEffectue"

        );
        notifier("Paiement enregistré.", "success");
        window.dispatchEvent(new CustomEvent("caisse:a-jour"));
        this.close();
      }
      catch(error){
        notifier(messageErreur(error, "Le paiement n'a pas pu être enregistré."));


      }



      finally{


        this.isLoading=false;


      }





    },






  },



};

</script>







<style scoped>


.modal-backdrop {

  position:fixed;

  inset:0;

  background:rgba(0,0,0,0.5);

  display:flex;

  align-items:center;

  justify-content:center;

  z-index:999;


}



.modal-content {


  background:white;

  padding:20px;

  border-radius:12px;

  width:800px;

  max-width:95%;

  max-height:90vh;

  display:flex;

  flex-direction:column;


}




.modal-body-scroll {


  overflow-y:auto;

  padding-right:5px;


}


</style>